import { render } from "./XCalenderMenu.vue?vue&type=template&id=ab8dd5ce"
import script from "./XCalenderMenu.vue?vue&type=script&lang=js"
export * from "./XCalenderMenu.vue?vue&type=script&lang=js"

import "./XCalenderMenu.vue?vue&type=style&index=0&id=ab8dd5ce&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__